var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Add specific item to collection, if it doesn't already exist
 * @param {string[]} collection Collection to be updated
 * @param {string} item Current item
 * @return {string[]} The updated collection
 */
export var addToCollection = function (collection, item) {
    return item && collection.indexOf(item) < 0 ? __spread(collection, [item]) : collection;
};
//# sourceMappingURL=addToCollection.js.map